// Using react-relay 1.4.1, having this fragment and using @relay(mask: false) prevented
// variables from being passed down. Manually unmasking here is the interim solution
// TODO: REMOVE THIS when bumping relay

import { getSelector } from 'relay-runtime'; // To fix mask issue. See usage below

export const unmaskFragmentData = ({ relayContext, relayData, fragmentPropName, fragment }) => {
    let fragmentFunc = fragment[fragmentPropName];
    if (typeof fragmentFunc === 'object') {
        fragmentFunc = fragmentFunc.modern;
    }
    const selector = getSelector(relayContext.variables, fragmentFunc(), relayData);
    return relayContext.environment.lookup(selector).data;
};
